<div class="phase-content">
  @for (phaseStatus of phaseStatusList; track phaseStatus) {
    @if (phaseStatus.loaded) {
      <app-content-list
        [contentList]="phaseStatus.contentList"
        [hidden]="phaseStatus.id !== currentPhaseId"
        [phaseId]="phaseStatus.id"
        >
      </app-content-list>
    }
  }
</div>
